export function sortFormFields(fields = []) {
    return [...fields].sort((a, b) => a.seq - b.seq);
}

export function validateSchema(validations, data) {
    return validations.validateSync(data, { abortEarly: false });
}

export function constructValidationError(err) {
    const validationErrors = {};
    err.inner.forEach((error) => {
        if (error.path && !validationErrors[error.path]) {
            validationErrors[error.path] = error.message;
        }
    });
    return validationErrors;
}

const replaceFieldNameWithLabel = (message, fieldName, fieldLabel) => {
    return message.replace(fieldName, fieldLabel);
}

export function renderError(errors, fieldName, errorMessage, fieldLabel) {
    if (errors !== undefined && errors !== null && errors[fieldName]) {
        if (fieldLabel) {
            errorMessage = replaceFieldNameWithLabel(errors[fieldName], fieldName, fieldLabel);
        }
        return (
            <div className="fs-8">
                <small className="text-danger">{errorMessage || errors[fieldName]}</small>
            </div>
        );
    }
    return null;
}
